import { workOrderPoBusiness } from "api/bussiness/work-order-po/work-order-po-bussiness";
import { createAutoCompleteMetaDataByDomain } from "commons/ultilities/dynamic-form/auto-complete/providers/factory";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IForm } from "commons/ultilities/dynamic-form/models/form";
import { cloneDeep } from "lodash";
import {
  IAddStellaInspectionNote,
  IUpdateInspectionStellaNote,
} from "mobx-stores/_models/inspection-note/stella-inspection-note/stella-inspection-note";

import { AppearanceTypeEnum } from "commons/enum/appearance-type";
import { PrintPaperSPUnitEnum } from "commons/enum/foil-unit";
import { InspectionConclusionEnum } from "commons/enum/inspection";
import { date, number, string } from "yup";
import {
  getInspectionConclusionStatus,
  getLabelOfAppearance,
  getLabelOfPrintPaperSPUnit,
} from "./share";
export const getAddInspectionNoteFormSchema = (
  form: IForm,
): ObjectSchemaType<IAddStellaInspectionNote> => {
  const customerAutoCompleteMetaData =
    createAutoCompleteMetaDataByDomain("customer");

  return {
    number: {
      gridSize: 6,
      label: "Số phiếu",
      type: InputType.text,
      validattionYupSchema: string().max(64).required(),
    },
    inspectionDate: {
      gridSize: 6,
      label: "Ngày kiểm nghiệm",
      type: InputType.datePicker,
      validattionYupSchema: date().required(),
    },
    manufacturingDate: {
      gridSize: 6,
      label: "Ngày sản xuất",
      type: InputType.datePicker,
      validattionYupSchema: date().required(),
    },
    expireDate: {
      gridSize: 6,
      label: "Ngày hết hạn",
      type: InputType.datePicker,
    },
    workOrderPOId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Lệnh sản xuất",
      validattionYupSchema: string().required(),
      metaData: {
        searchOptionItemsAsync: async (keyword: string) => {
          return await workOrderPoBusiness.searchWoPoAsOptionItems(keyword);
        },
      },
    },
    customerId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Khách hàng",
      validattionYupSchema: string(),
      metaData: {
        ...(customerAutoCompleteMetaData || {}),
        autoCompleteDomain: "customer",
        autoCompleteMode: "paged",
      },
    },
    conclusion: {
      type: InputType.text,
      gridSize: 12,
      label: "Kết luận",
      validattionYupSchema: string(),
    },
    items: {
      label: "Chi tiết mặt hàng",
      type: InputType.array,
      arraySchema: {
        productId: {
          label: "Mặt hàng",
          gridSize: 12,
          type: InputType.autoComplete,
          validattionYupSchema: string().required(),
          defaultValue: "",
        },
        appearance: {
          label: "Ngoại quan",
          type: InputType.select,
          gridSize: 4,
          defaultValue: "",
          validattionYupSchema: string().required(),
          optionItems: [
            {
              value: AppearanceTypeEnum.Box,
              label: getLabelOfAppearance(AppearanceTypeEnum.Box),
            },
            {
              value: AppearanceTypeEnum.Tray,
              label: getLabelOfAppearance(AppearanceTypeEnum.Tray),
            },
          ],
        },
        appearanceResult: {
          label: "Kết quả",
          gridSize: 4,
          type: InputType.text,
          validattionYupSchema: string(),
          defaultValue: "",
        },
        appearanceConclusion: {
          label: "Kết luận",
          gridSize: 4,
          type: InputType.select,
          validattionYupSchema: string(),
          defaultValue: InspectionConclusionEnum.None,
          optionItems: getInspectionConclusionStatus(),
        },
        length: {
          label: "Quy cách dài:",
          type: InputType.label,
          gridSize: 4,
          defaultValue: "",
        },
        lengthResult: {
          label: "Kết quả",
          gridSize: 4,
          type: InputType.number,
          validattionYupSchema: number(),
          defaultValue: 0,
        },
        lengthConclusion: {
          label: "Kết luận",
          gridSize: 4,
          type: InputType.select,
          validattionYupSchema: string(),
          defaultValue: InspectionConclusionEnum.None,
          optionItems: getInspectionConclusionStatus(),
        },
        width: {
          label: "Quy cách rộng:",
          type: InputType.label,
          gridSize: 4,
          defaultValue: "",
        },
        widthResult: {
          label: "Kết quả",
          gridSize: 4,
          type: InputType.number,
          validattionYupSchema: number(),
          defaultValue: 0,
        },
        widthConclusion: {
          label: "Kết luận",
          gridSize: 4,
          type: InputType.select,
          validattionYupSchema: string(),
          defaultValue: InspectionConclusionEnum.None,
          optionItems: getInspectionConclusionStatus(),
        },
        height: {
          label: "Quy cách cao:",
          type: InputType.label,
          gridSize: 4,
          defaultValue: "",
        },
        heightResult: {
          label: "Kết quả",
          gridSize: 4,
          type: InputType.number,
          validattionYupSchema: string(),
          defaultValue: 0,
        },
        heightConclusion: {
          label: "Kết luận",
          gridSize: 4,
          type: InputType.select,
          validattionYupSchema: string(),
          defaultValue: InspectionConclusionEnum.None,
          optionItems: getInspectionConclusionStatus(),
        },
        quantification: {
          label: "Định lượng:",
          type: InputType.label,
          gridSize: 4,
          defaultValue: "",
        },
        quantificationResult: {
          label: "Kết quả",
          gridSize: 4,
          type: InputType.number,
          validattionYupSchema: string(),
          defaultValue: 0,
        },
        quantificationConclusion: {
          label: "Kết luận",
          gridSize: 4,
          type: InputType.select,
          validattionYupSchema: string(),
          defaultValue: InspectionConclusionEnum.None,
          optionItems: getInspectionConclusionStatus(),
        },
        foil: {
          label: "Độ cao hạt nổi:",
          type: InputType.label,
          gridSize: 4,
          defaultValue: "",
        },

        foilResult: {
          label: "Kết quả",
          gridSize: 4,
          type: InputType.number,
          validattionYupSchema: number(),
          defaultValue: 0,
        },
        foilConclusion: {
          label: "Kết luận",
          gridSize: 4,
          type: InputType.select,
          validattionYupSchema: string(),
          defaultValue: InspectionConclusionEnum.None,
          optionItems: getInspectionConclusionStatus(),
        },
        foldingStandardSize: {
          label: "Kích thước gấp",
          type: InputType.label,
          gridSize: 4,
          defaultValue: "",
        },
        foldingStandardSizeResult: {
          label: "Kết quả",
          gridSize: 4,
          type: InputType.text,
          validattionYupSchema: string().max(512),
          defaultValue: "",
        },
        foldingStandardSizeConclusion: {
          label: "Kết luận",
          gridSize: 4,
          type: InputType.select,
          validattionYupSchema: string(),
          defaultValue: InspectionConclusionEnum.None,
          optionItems: getInspectionConclusionStatus(),
        },

        foldingStandardCount: {
          label: "Số lượng gấp",
          type: InputType.label,
          gridSize: 4,
          defaultValue: "",
        },
        foldingStandardCountResult: {
          label: "Kết quả",
          gridSize: 4,
          type: InputType.text,
          validattionYupSchema: string().max(512),
          defaultValue: "",
        },
        foldingStandardCountConclusion: {
          label: "Kết luận",
          gridSize: 4,
          type: InputType.select,
          validattionYupSchema: string(),
          defaultValue: InspectionConclusionEnum.None,
          optionItems: getInspectionConclusionStatus(),
        },

        printPaperSP: {
          label: "Số hộp (toa)/ Bản In :",
          gridSize: 4,
          type: InputType.label,
          validattionYupSchema: string(),
          defaultValue: "",
        },
        printPaperSPUnit: {
          label: "",
          type: InputType.select,
          gridSize: 8,
          defaultValue: "",
          validattionYupSchema: string().required(),
          optionItems: [
            {
              value: PrintPaperSPUnitEnum.prescription,
              label: getLabelOfPrintPaperSPUnit(
                PrintPaperSPUnitEnum.prescription,
              ),
            },
            {
              value: PrintPaperSPUnitEnum.Box,
              label: getLabelOfPrintPaperSPUnit(PrintPaperSPUnitEnum.Box),
            },
          ],
        },
        amount: {
          label: "Số lượng",
          gridSize: 12,
          type: InputType.text,
          validattionYupSchema: string(),
          defaultValue: "",
        },
      },
    },
  };
};

export const getEditInspectionNoteFormSchema = (
  form: IForm,
): ObjectSchemaType<IUpdateInspectionStellaNote> => {
  const schema = getAddInspectionNoteFormSchema(form);
  const updateSchema: ObjectSchemaType<IUpdateInspectionStellaNote> =
    cloneDeep(schema);
  updateSchema.id = {
    type: InputType.none,
  };
  updateSchema.workOrderId = {
    type: InputType.none,
  };
  updateSchema.items.arraySchema.id = {
    type: InputType.none,
  };
  return updateSchema;
};
